import React from 'react';
import './RasWithdrawThresholdModal.scss';

const RasWithdrawThresholdModal = () => {
  return (
    <div className="ras-withdraw-max-info-modal">
      <h4> Withdraw Threshold </h4>
      <p>
        You are about to withdraw a level of assets from your Retirement
        Advisory Service accounts that may have unexpected impact to your
        financial plan. Please contact your advisor for guidance if you have
        questions or concerns.
      </p>
    </div>
  );
};

export default RasWithdrawThresholdModal;
